import { useCallback, useEffect, useRef } from 'react'

export function usePostDragClickGuard() {
  const suppressedRef = useRef(false)
  const releaseTimerRef = useRef<number | null>(null)

  const begin = useCallback(() => {
    if (releaseTimerRef.current !== null) {
      window.clearTimeout(releaseTimerRef.current)
    }
    suppressedRef.current = true
  }, [])

  const end = useCallback(() => {
    // Chromium's synthetic click may land on a sibling after Framer reports
    // drag end, so retain the guard through this event-loop turn.
    releaseTimerRef.current = window.setTimeout(() => {
      suppressedRef.current = false
      releaseTimerRef.current = null
    }, 0)
  }, [])

  useEffect(() => {
    return () => {
      if (releaseTimerRef.current !== null) {
        window.clearTimeout(releaseTimerRef.current)
      }
    }
  }, [])

  const shouldSuppress = useCallback((): boolean => suppressedRef.current, [])
  return { begin, end, shouldSuppress }
}
